import {ClaimRelatedShipmentTypeCd} from '../';
import {EnumHelper} from './enum-helper';

export class ClaimRelatedShipmentTypeCdHelperEnumHelperClass extends EnumHelper {

  public constructor() {
  	super();
    for ( const obj in ClaimRelatedShipmentTypeCd ) {
      this._values.push(ClaimRelatedShipmentTypeCd[obj]);
      this._keys.push(obj);
    }
  }

  public toEnum(value: string): ClaimRelatedShipmentTypeCd {

    for ( const obj in ClaimRelatedShipmentTypeCd ) {
      if (ClaimRelatedShipmentTypeCd[obj] === value){
        return ClaimRelatedShipmentTypeCd[obj] as ClaimRelatedShipmentTypeCd;
      }
    }
  }
}

const ClaimRelatedShipmentTypeCdHelper = new ClaimRelatedShipmentTypeCdHelperEnumHelperClass();
export default ClaimRelatedShipmentTypeCdHelper;
